var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{class:[
    _vm.$style['base-data-container'],
    _vm.isShowBg ? _vm.$style['is-showBg'] : '',
  ]},_vm._l((_vm.configData),function(item){return _c('li',{key:item.title,class:[_vm.$style.item, _vm.isClick ? _vm.$style.click : ''],on:{"click":function($event){return _vm.showDialogHandle(item)}}},[_c('h3',[_vm._v(_vm._s(item.value))]),_c('p',{class:_vm.$style.title,attrs:{"title":item.title}},[_vm._v(_vm._s(item.title))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }